import {FooterTabFragment, FooterTabFragmentProps, FooterTabFragmentState} from "../shared/FooterTabFragment";
import React, {ReactElement} from "react";
import {StyledBoxColumn} from "../shared/StyledComponents";
import {THEME_BG} from "./App";

export abstract class BaseAppTabFragment<P extends FooterTabFragmentProps = FooterTabFragmentProps, S extends FooterTabFragmentState = FooterTabFragmentState> extends FooterTabFragment<P, S> {

  renderContent(): ReactElement {
    return <StyledBoxColumn style={{
      background: THEME_BG,
      flexGrow: 1
    }}>
      {this.renderTabContent()}
    </StyledBoxColumn>
  }

  abstract renderTabContent(): ReactElement;
}